module.exports = __webpack_public_path__ + "img/copyright.4b828f99.jpg";